import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Image from "next/image";
import { useAppContext } from "../../../_context";
import reactStringReplace from "react-string-replace";

const CareerEmailUs = () => {
  const [{ tx }] = useAppContext();

  return (
    <section className="email-us section-padding-y">
      <Container>
        <Row>
          <Col md={10} lg={8} className="d-flex flex-wrap m-auto">
            <Col
              xs={12}
              md={4}
              className="text-center text-md-start mb-4 mb-md-0">
              <Image
                src="/img/careers/email.png"
                width={273}
                height={256}
                unoptimized={true}
              />
            </Col>
            <Col xs={12} md={8} className="d-flex align-items-center">
              <div className="w-100 ps-md-4">
                <h3>{tx["Can't see the job you're looking for?"]}</h3>
                <p>
                  {reactStringReplace(
                    tx[
                      "We'd still love to hear from you. Send us your CV to :email and let us know what you bring to the party."
                    ],
                    ":email",
                    (match, i) => (
                      <a
                        key={i}
                        className="text-primary"
                        href="mailto:work@racketpal.co.uk">
                        work@racketpal.co.uk
                      </a>
                    ),
                  )}
                </p>
              </div>
            </Col>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default CareerEmailUs;
